// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_2-3";
export var dialog = "_2-0";
export var divClassnameSwatch = "_2-8";
export var flexSwatch = "_2-4";
export var header = "_2-1";
export var styleAttributeSwatch = "_2-7";
export var swatch = "_2-2";
export var textHeaderSwatch = "_2-5";
export var webSwatch = "_2-6";